import { Link } from "react-router-dom"
import Icon from "@/components/common/Icon"

interface EntryCompleteDialogProps {
  entryNo: string
}

export default function EntryCompleteDialog({
  entryNo,
}: Readonly<EntryCompleteDialogProps>) {
  return (
    <div className="app-dialog-backdrop">
      <div
        role="dialog"
        aria-modal="true"
        aria-labelledby="entry-complete-title"
        className="app-dialog p-8 text-center"
      >
        <span className="mx-auto flex size-14 items-center justify-center bg-app-primary-500 text-app-text-100">
          <Icon
            name="check"
            size={26}
          />
        </span>

        <p className="app-txt-eyebrow mt-6 text-app-primary-600">
          APPLICATION COMPLETE
        </p>
        <h2
          id="entry-complete-title"
          className="app-txt-h2 mt-3"
        >
          참가 신청이 완료되었습니다
        </h2>

        <div className="app-inset mt-6 py-5">
          <p className="app-txt-caption text-app-text-200">신청번호</p>
          <p className="app-txt-h2 mt-1 font-mono text-app-primary-600">
            {entryNo}
          </p>
        </div>

        <p className="app-txt-body2 mt-5 leading-6 text-app-text-300">
          신청번호를 보관해 주세요. 신청 조회 · 수정 · 취소에는 체육관 연락처와
          직접 정한 신청 비밀번호가 필요합니다.
        </p>

        <Link
          to="/fee"
          className="focus-ring app-btn app-btn-primary app-btn-block mt-7"
        >
          참가비 · 입금 계좌 확인
        </Link>
        <Link
          to="/application/lookup"
          className="focus-ring app-btn app-btn-ink app-btn-block mt-3"
        >
          신청 내역 조회하기
        </Link>
      </div>
    </div>
  )
}
